/**=========================================================
 * Module: translation.js
 * Translation Controller
 =========================================================*/

App.controller('TranslationController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService',
   'Restangular', 'DataService', 'ngDialog', '$filter',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter) {
    "use strict";

    $scope.type = 'translation';
    $scope.filter = $state.params.filter;
	if($scope.filter.endsWith('-review')){
		$scope.displayStatus = 'REVIEW'
		$scope.filter = $scope.filter.substring(0, $scope.filter.length - '-review'.length)
		$scope.showReviewMessages = true
	}

    $scope.data = [];


	$scope.onTranslationChanged = function(){
		D.load($scope.type, $scope.filter).then(
			function(response){
				if(response.status!=$scope.model.status){
					$timeout(function(){
						$state.go($state.current, {}, {reload: true}); 
					}, 2000)
				}
			}).catch(console.error)
	}

	$scope.openAdminNotes = function(){

        $scope.changeANForm = {
            title: '',
            status: '',
            type: 'project',
            model: $scope.model,
            fields: [
                {
                    available: true,
                    type: 'textarea',
                    name: 'adminNotes',
                    noLabel: true,
                    rows: 10,
                    labelColumn: 0,
                    inputColumn: 12
                }
            ],
            submit: function(){
                
            }
        }

        ngDialog.open({
                          template: '/app/views/entities/project-adminnotes.html',
                          className: 'ngdialog-theme-default ngdialog-theme-large',
                          scope: $scope,
                          cache: false
                        });
    };

	$scope.enableUploadForm = function(){
		$scope.disabledUploadForm = false
	}

    $scope.initialized = false;
    $scope.watchActivated = false;
	
    $scope.init = function(fromStatusChange){
		$scope.initializing = true
        if($rootScope.user.id){
			$scope.initialized = true;
			
			

            D.load($scope.type, $scope.filter).then(
                    function(response){
						$scope.model = response;
						
						FIREBASE.listen('Translation', $scope.filter, function(value){
							if(value && FIREBASE.isAfter(value.timestamp,$scope.model.T)){
								$scope.onTranslationChanged(value);
							}
							
						}, null, { interval: 60000 });

                        D.load('project', $scope.model.project, { cache: false }).then(
                                function(response){
									$scope.initializing = false
									$scope.project = response;

									if($scope.project.group=='aag' && $rootScope.user.admin && $scope.model.status!='DELIVERED'){
										D.save('translation', { id: $scope.model.id, action: 'checkExistingFileOnWebdav'}).then(function(response){

										}).catch(function(err){
											if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
												if(err.data.msg.indexOf('webdavFileExists=')===0){
													$scope.webdavFileExists = err.data.msg.substring('webdavFileExists='.length)
												}
												if(err.data.msg.indexOf('webdavCheck=')===0){
													$scope.webdavFileExists = 'CHECKERROR'
												}
											}
										})
									}

									$scope.model.assignee = $scope.project.assignee;
									$scope.model.assigneeName = $scope.project.assigneeName;
									$scope.model.adminNotes = $scope.project.adminNotes;
									let statusConfigurations = [
										{ status: 'TRANSLATION', agent: $scope.project.supplierName, when: (s) => !s.hasZeroWords },
										{ status: 'SUPPLIERREVISION', agent: $scope.project.supplierName, when: (s) => s.hasZeroWords && !s.linguisticTask },
										{ status: 'LINGUISTICTASK', agent: $scope.project.supplierName, when: (s) => s.hasZeroWords && s.linguisticTask },
										{ status: 'REVIEW', agent: $filter('translate')('fields.REVIEWER'), when: (s) => (!s.dtp && s.review) || (s.dtp && s.review && s.anticipateReview) },
										{ status: 'IMPORT', agent: 'Aqrate', when: (s) => true },
										{ status: 'LAYOUT', agent: $scope.project.supplierName, when: (s) => s.dtp },
										{ status: 'REVIEW', agent: $filter('translate')('fields.REVIEWER'), when: (s) => s.dtp && s.review && !s.anticipateReview },
										{ status: 'REVISION', agent: 'Aqrate', when: (s) => s.dtp },
										{ status: 'DELIVERED', agent: $scope.project.groupName, when: (s) => true }
									]
									$scope.statusesIcons = {
										'TRANSLATION':'language', 
										'IMPORT':'indent', 
										'LAYOUT':'columns', 
										'REVISION':'clipboard', 
										'DELIVERED':'archive',
										'REVIEW': 'recycle',
										'SUPPLIERREVISION': 'language',
										'LINGUISTICTASK': 'language'
									}
									$scope.statuses = []
									$scope.agent = []
									if($scope.model.startFromStatus=='TRANSLATION' && $scope.model.hasZeroWords && !$scope.model.opts.linguisticTask){ $scope.model.startFromStatus = 'SUPPLIERREVISION' }
									if($scope.model.startFromStatus=='TRANSLATION' && $scope.model.hasZeroWords && $scope.model.opts.linguisticTask){ $scope.model.startFromStatus = 'LINGUISTICTASK' }
									for(var i=0; i<statusConfigurations.length; i++){
										if(statusConfigurations[i].when({ 
											dtp: $scope.project.dtp, 
											review: $scope.model.review, 
											anticipateReview: $scope.model.anticipateReview,
											hasZeroWords: $scope.model.hasZeroWords, 
											linguisticTask: $scope.model.opts && $scope.model.opts.linguisticTask 
										})){
											if(!$scope.model.startFromStatus || $scope.model.startFromStatus==statusConfigurations[i].status || $scope.statuses.indexOf($scope.model.startFromStatus)>=0){
												$scope.statuses.push(statusConfigurations[i].status)
												$scope.agent.push(statusConfigurations[i].agent)
											}
										}
									}

									if($scope.project.glossary && $rootScope.user.customRole=='REVIEWER'){
										$scope.glossaryFiles = []
										$scope.lastGlossaryDate = null
										D.query('file', { type: 'group', field: 'glossary', entityId: $scope.project.group }, { cache: false }).then(function(response){
											for(var i=0; i<response.length; i++){
												if($scope.project.glossary.indexOf(response[i].name)>=0){
													$scope.glossaryFiles.push(response[i])
													if($scope.lastGlossaryDate==null || $scope.lastGlossaryDate<response[i].createdOn){
														$scope.lastGlossaryDate = response[i].createdOn
													}
												}
											}
										}).catch(console.error)
									}
									
									$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
									if($scope.model.status=='DELIVERED') $scope.currentStatusIndex++;
									$scope.showQA = $scope.project.createdOn >= new Date(2018, 0, 1).getTime();

                                    $scope.page = {
                                            title: 'labels.TRANSLATIONOF',
                                            titleParams: { projectName: $scope.project.name },
                                            subTitle: 'labels.TRANSLATIONFROMTO',
                                            subTitleParams: { fromLang: $scope.model.source, toLang: $scope.model.destination },
                                            //label: 'enums.translationStatus.'+$scope.model.status,
											labelCls: 'label-default',
											isTranslation: true
                                        };

                                    $scope.message = '';
                                    $scope.messageParams = { supplierName: $scope.project.supplierName };
									$scope.downloadFiles = [];
									$scope.filesDownloaded = null
									$scope.noDownload = false;
                                    $scope.showBack = false;

									$scope.uploadForm = null
                                    $scope.backForm = {
                                            title: 'labels.TRANSLATIONBACKFROM'+ ($scope.model.opts && $scope.model.opts.reviewStatus=='underReview' ? 'UNDERREVIEW' : $scope.model.status),
                                            status: '',
                                            type: 'translation',
                                            model: $scope.model,
                                            fields: [
                                                {
                                                    available: true,
                                                    type: 'submit',
                                                    name: 'empty',
                                                    label: 'labels.TRANSLATIONBACK',
                                                    labelColumn: 0
                                                }
                                            ],
                                            submit: function(){
                                            	ngDialog.openConfirm({
                                                    template: '/app/views/entities/translation-confirmback.html',
                                                    className: 'ngdialog-theme-default',
                                                    scope: $scope
                                                  }).then(function (value) {
                                                	  $scope.backForm.status = 'submitting';
                                                	  $scope.backForm.model.action = 'back';
	                                                    D.save('translation', $scope.backForm.model).then(
	                                                        function(response){
	                                                        	$timeout(function(){ $state.go('app.entity', {
	                					        					 type: 'project',
	                					        					 filter: $scope.model.project,
	                					        					 action: 'process'
	                					        				 }, { reload: true }); }, CONFIG.stateGoTimeout)
	                                                        }
	                                                        
	                                                    ).catch(function(response){
	                                                        	$scope.backForm.status = 'error';
	                                                        });
                                                  });
                                            }
                                        }
									
                                    if($rootScope.user.groupType=='SUPPLIER'){
										if($scope.model.status=='TRANSLATION' && !$scope.displayStatus){//SUPPLIER
											var aId = $scope.project.id + '-' + $scope.model.source + '-' + $scope.model.destination;
											$scope.dfType = 'analysis';
											$scope.dfField = 'upload';
											$scope.dfId = aId;
											$scope.dfExt = 'xliff|tmx|zip|mqxlz|mqxliff'
											if($rootScope.user.group.opts.canviewcsv){
												$scope.dfExt += '|csv'
											}
											var isTranslationToReview = ($scope.model.review && !$scope.model.skipReview && !$scope.project.dtp) || ($scope.model.review && !$scope.model.skipReview && $scope.project.dtp && $scope.model.anticipateReview)
											
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											if($scope.model.opts && $scope.model.opts.reviewStatus==='underReview'){
												$scope.model.status = 'SUPPLIERREVISION'
												$scope.dfType = 'translation'
												$scope.dfField = 'review'
												$scope.dfExt = ''
												$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.SUPPLIERREVISION').replace(/\s/g,'_')
												$scope.filesDownloaded = false
												D.query('file', 'type=translation&entityId='+aId+'&field=review', { cache: false }).then(
	                                                function(response){
	                                                    $scope.downloadFiles = response;
														$scope.filesDownloaded = true
	                                                });
											} else {
												$scope.filesDownloaded = false
	                                    		D.query('file', 'type=analysis&entityId='+aId+ '&extension='+$scope.dfExt +'&field=upload', { cache: false }).then(
	                                                function(response){
	                                                    $scope.downloadFiles = response;
														$scope.filesDownloaded = true
	                                                }).catch(console.error);
											}
	                                    	$scope.uploadForm = {
	                                                title: $scope.model.hasZeroWords ? ($scope.model.opts.linguisticTask ? 'labels.LOADLINGUISTICTASKXLIFF' : 'labels.LOADREVIEWEDXLIFF') : (!isTranslationToReview ? 'labels.LOADTRANSLATIONXLIFF' : 'labels.LOADTRANSLATIONTOREVIEW'),
	                                                titleParams: { lang: $scope.model.destination},
	                                                status: 'notsubmittable',
	                                                type: 'translation',
	                                                model: $scope.model,
	                                                refreshFile: function(data){
	                                                	if($rootScope.files['translation'+this.model.id+'translation'] && $rootScope.files['translation'+this.model.id+'translation'].length>0)
	                                                		this.status = '';
	                                                	else
	                                                		this.status = 'notsubmittable';
	                                                },
	                                                fields: [
	                                                    {
	                                                        available: true,
	                                                        type: 'submit',
	                                                        name: 'empty',
	                                                        label: $scope.model.hasZeroWords ? ($scope.model.opts.linguisticTask ? 'labels.SENDLINGUISTICTASK' : 'labels.SENDSUPPLIERREVISION') : (!isTranslationToReview ? 'labels.SENDTRANSLATE' : 'labels.SENDREVIEW'),
															labelColumn: 0,
															cls: 'btn-lg pulse-button',
															tooltip: {
																name: 'SENDTRANSLATION',
																wait: 2,
																position: 'right',
																attachTo: '.app-field-empty input',
																arrowSize: 'long'
															}
			
	                                                    },{
	                                                        available: true,
	                                                        type: 'file',
	                                                        name: 'translation',
	                                                        canUpload: true,
	                                                        noLabel: true,
	                                                        inputColumn: 12,
	                                                        limit: -1,
	                                                        allow: isTranslationToReview ? '' : 'xliff|zip|mqxlz|mqxliff',
															noOverwrittenAlert: true,
															bucket: $rootScope.bucketName($scope.project.group)
	                                                    }
	                                                ],
	                                                submit: function(){
	                                                    this.status = 'submitting';
	                                                    this.model.action = !isTranslationToReview ? 'translate' : 'review';
	                                                    D.save('translation', this.model).then(
	                                                        function(response){
																$scope.model = response;
																$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
	                                                        	$scope.uploadForm.status = 'notsubmittable';
	                                                        	$scope.uploadForm.showSuccess=true;
																$scope.uploadForm.fields.forEach(function(f){
																	if(f.type=='file') f.cantDelete = true;
																})
																$scope.init()
	                                                        }
	                                                        
	                                                    ).catch(function(response){
	                                                        	$scope.uploadForm.status = 'error';
	                                                        });

	                                                }
	                                            };
	                                    } else if($scope.model.status=='IMPORT' && !$scope.displayStatus){//SUPPLIER
	                                    	$scope.message = 'labels.TRANSLATIONINIMPORT';
											$scope.uploadForm = {
												title: $scope.model.hasZeroWords ? ($scope.model.opts.linguisticTask ? 'labels.LOADLINGUISTICTASKXLIFF' : 'labels.LOADREVIEWEDXLIFF') : 'labels.LOADTRANSLATIONXLIFF',
												titleParams: { lang: $scope.model.destination},
												status: 'notsubmittable',
												type: 'translation',
												model: $scope.model,
												fields: [
													{
														available: true,
														type: 'file',
														name: 'translation',
														canUpload: false,
														noLabel: true,
														inputColumn: 12,
														limit: -1,
														allow: 'xliff|zip|mqxlz|mqxliff',
														noOverwrittenAlert: true,
														cantDelete: true,
														bucket: $rootScope.bucketName($scope.project.group)
													}
												]
											}
	                                    } else if($scope.model.status=='LAYOUT' && !$scope.displayStatus){//SUPPLIER
											var aId = $scope.model.id;
											$scope.dfType = 'translation';
											$scope.dfField = 'layout';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field=layout', { cache: false }).then(
	                                                function(response){
														$scope.downloadFiles = response;
														if(response.length===0){
															$scope.dfType = 'analysis';
															$scope.dfField = 'upload';
															$scope.dfId = aId;
															$scope.dfExt = 'xliff|tmx|zip|mqxlz|mqxliff'
															$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
															D.query('file', 'type=analysis&entityId='+aId+'&extension=xliff|tmx|zip|mqxlz|mqxliff&field=upload', { cache: false }).then(
																function(response){
																		$scope.downloadFiles = response;
																		$scope.filesDownloaded = true
																});
														} else {
															$scope.filesDownloaded = true
														}
	                                                },
	                                                function(response){

	                                                }).catch(console.error);
	                                    	$scope.showBack = true;
											if($scope.model.startFromStatus=='LAYOUT'){ $scope.showBack = false }
	                                    	$scope.model.backStatus = 'IMPORT';
	                                    	$scope.uploadForm = {
	                                                title: 'labels.LOADTRANSLATIONLAYOUT',
	                                                titleParams: { lang: $scope.model.destination},
	                                                status: 'notsubmittable',
	                                                type: 'translation',
	                                                model: $scope.model,
	                                                refreshFile: function(data){
	                                                	if($rootScope.files['translation'+this.model.id+'revision'] && $rootScope.files['translation'+this.model.id+'revision'].length>0 && this.status!='submitting')
	                                                		this.status = '';
	                                                	else
	                                                		this.status = 'notsubmittable';
	                                                },
	                                                fields: [
														{
	                                                        available: true,
	                                                        type: 'submit',
	                                                        name: 'empty',
	                                                        label: $scope.model.review && !$scope.model.anticipateReview ? 'labels.SENDREVIEW' : 'labels.SENDREVISION',
															labelColumn: 0,
															cls: 'btn-lg pulse-button'
	                                                    },
	                                                    {
	                                                        available: true,
	                                                        type: 'file',
	                                                        name: 'revision',
	                                                        canUpload: true,
	                                                        noLabel: true,
	                                                        inputColumn: 12,
	                                                        limit: -1,
															noOverwrittenAlert: true,
															bucket: $rootScope.bucketName($scope.project.group)
	                                                    }
	                                                ],
	                                                submit: function(){
	                                                    this.status = 'submitting';
	                                                    this.model.action = $scope.model.review && !$scope.model.anticipateReview ? 'review' : 'revision';
	                                                    D.save('translation', this.model).then(
	                                                        function(response){
																$scope.model = response;
																$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
	                                                            $scope.uploadForm.status = 'notsubmittable';
	                                                            $scope.uploadForm.showSuccess=true;
																$scope.uploadForm.fields.forEach(function(f){
																	if(f.type=='file') f.cantDelete = true;
																})
																$scope.init()
	                                                        }
	                                                        
	                                                    ).catch(function(response){
	                                                        	$scope.uploadForm.status = 'error';
	                                                        });

	                                                }
	                                            };
	                                    } else if($scope.model.status=='REVIEW' || $scope.displayStatus=='REVIEW'){//SUPPLIER
											
	                                    	$scope.showBack = false;
	                                    	$scope.model.backStatus = 'IMPORT';
											$scope.disabledUploadForm = true
											$scope.enableUploadFormButtonLabel = 'labels.ENABLEUPLOADFORMREVIEW'
											$scope.uploadFormAlert = 'labels.REVIEWFORMALERT'
	                                    	$scope.uploadForm = {
	                                                title: '',
	                                                titleParams: { lang: $scope.model.destination},
	                                                status: 'notsubmittable',
	                                                type: 'translation',
	                                                model: $scope.model,
	                                                refreshFile: function(data){
	                                                	if($rootScope.files['translation'+this.model.id+ ($scope.project.dtp && !$scope.model.anticipateReview ? 'revision' : 'translation')] && $rootScope.files['translation'+this.model.id+ ($scope.project.dtp && !$scope.model.anticipateReview ? 'revision' : 'translation')].length>0 && this.status!='submitting')
	                                                		this.status = '';
														else
	                                                		this.status = 'notsubmittable';
	                                                },
	                                                fields: [
														{
	                                                        available: true,
	                                                        type: 'submit',
	                                                        name: 'empty',
	                                                        label: $scope.project.dtp && !$scope.model.anticipateReview ? 'labels.SENDREVISION' : 'labels.SENDTRANSLATE',
															labelColumn: 0,
															cls: 'btn-lg pulse-button'
	                                                    },
	                                                    {
	                                                        available: $scope.project.dtp && !$scope.model.anticipateReview,
	                                                        type: 'file',
	                                                        name: 'revision',
	                                                        canUpload: true,
															label: 'labels.LOADTRANSLATIONLAYOUT',
	                                                        inputColumn: 12,
															labelColumn: 12,
															labelAlign: 'left',
															labelParams: { lang: $scope.model.destination },
	                                                        limit: -1,
															noOverwrittenAlert: true,
															bucket: $rootScope.bucketName($scope.project.group)
	                                                    },{
	                                                        available: true,
	                                                        type: 'file',
	                                                        name: 'translation',
	                                                        canUpload: true,
	                                                        label: 'labels.LOADTRANSLATIONXLIFF',
	                                                        inputColumn: 12,
															labelColumn: 12,
															labelAlign: 'left',
															labelParams: { lang: $scope.model.destination },
	                                                        limit: -1,
	                                                        allow: 'xliff|zip|mqxlz|mqxliff',
															noOverwrittenAlert: true,
															bucket: $rootScope.bucketName($scope.project.group)
	                                                    }
	                                                ],
	                                                submit: function(){
	                                                    this.status = 'submitting';
	                                                    this.model.action = $scope.project.dtp && !$scope.model.anticipateReview ? 'revision' : 'translate';
	                                                    D.save('translation', this.model).then(
	                                                        function(response){
																$scope.model = response;
																$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
	                                                            $scope.uploadForm.status = 'notsubmittable';
	                                                            $scope.uploadForm.showSuccess=true;
																$scope.uploadForm.fields.forEach(function(f){
																	if(f.type=='file') f.cantDelete = true;
																})
																$scope.init()
	                                                        }
	                                                        
	                                                    ).catch(function(response){
	                                                        	$scope.uploadForm.status = 'error';
	                                                        });

	                                                }
	                                            };
												if($scope.model.status!='REVIEW' || $scope.model.opts.reviewMode=='memoQ') $scope.uploadForm = null
	                                    } else if($scope.model.status=='REVISION' && !$scope.displayStatus){//SUPPLIER
	                                    	$scope.message = 'labels.TRANSLATIONREVISION';
	                                    } else if($scope.model.status=='DELIVERED' && !$scope.displayStatus){//SUPPLIER
	                                    	//$scope.message = 'labels.TRANSLATIONDELIVERED';
	                                    	var aId = $scope.model.id;
											var filter = $scope.project.dtp ? 'revision' : 'translation';
											$scope.dfType = 'translation';
											$scope.dfField = filter;
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field='+filter, { cache: false }).then(
	                                                function(response){
	                                                    $scope.downloadFiles = response;
														$scope.filesDownloaded = true
	                                                },
	                                                function(response){

	                                                }).catch(console.error);
	                                    }
									} else if($rootScope.user.groupType=='CLIENT' && $rootScope.user.customRole=='REVIEWER'){
										$scope.reviewer = $rootScope.user
										$scope.showBack = false;
										$scope.uploadForm = null
										if(($scope.project.dtp && ($scope.model.status=='TRANSLATION' || $scope.model.status=='IMPORT' || $scope.model.status=='LAYOUT') && !$scope.model.anticipateReview) 
											|| ((!$scope.project.dtp || $scope.model.anticipateReview) && ($scope.model.status=='TRANSLATION'))){
											$scope.message = 'labels.TRANSLATIONNOTYETINREVIEW';
										} else {
											$scope.uploadFormAlert = $scope.model.status=='REVIEW' && $scope.model.opts.reviewMode!='memoQ' ? 'labels.REVIEWFORMALERTREVIEWER' : ''
											$scope.uploadForm = {}
											$scope.disabledUploadForm = true
											$scope.showReviewMessages = true
											$scope.message = $scope.model.status=='REVIEW' ? '' : 'labels.TRANSLATIONAFTERREVIEW';
										}
                                    } else if($rootScope.user.groupType=='CLIENT' && $rootScope.user.customRole!='REVIEWER'){
	                                    if($scope.model.status=='TRANSLATION' && !$scope.displayStatus){//CLIENT
											$scope.message = 'labels.TRANSLATIONTRANSLATION';
											if($scope.model.hasZeroWords){
												$scope.message = 'labels.TRANSLATIONSUPPLIERREVISION'
												if($scope.model.opts.linguisticTask){
													$scope.message = 'labels.TRANSLATIONLINGUISTICTASK'
												}
											}
	                                    } else if($scope.model.status=='IMPORT' && !$scope.displayStatus){//CLIENT
											$scope.message = 'labels.TRANSLATIONINIMPORT';
											var aId = $scope.model.id;
											$scope.dfType = 'translation';
											$scope.dfField = 'translation';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
											D.query('file', 'type=translation&entityId='+aId+'&field=translation', { cache: false }).then(
												function(response){
													$scope.downloadFiles = response;
													$scope.noDownload = true;
													$scope.filesDownloaded = true
												},
												function(response){

												}).catch(console.error);
	                                    } else if($scope.model.status=='LAYOUT' && !$scope.displayStatus){//CLIENT
											$scope.message = 'labels.TRANSLATIONLAYOUT';
											var aId = $scope.model.id;
											$scope.dfType = 'translation';
											$scope.dfField = 'layout';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field=layout', { cache: false }).then(
	                                                function(response){
														$scope.downloadFiles = response;
														$scope.noDownload = true;
														if(response.length===0){
															$scope.dfType = 'analysis';
															$scope.dfField = 'upload';
															$scope.dfId = aId;
															$scope.dfExt = 'xliff|tmx|zip|mqxlz|mqxliff';
															$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
															D.query('file', 'type=analysis&entityId='+aId+'&extension=xliff|tmx|zip|mqxlz|mqxliff&field=upload', { cache: false }).then(
																function(response){
																		$scope.downloadFiles = response;
																		$scope.filesDownloaded = true
																}).catch(console.error);
														} else {
															$scope.filesDownloaded = true
														}
	                                                }).catch(console.error);
	                                    } else if($scope.model.status=='REVISION' && !$scope.displayStatus){//CLIENT
	                                    	$scope.message = 'labels.TRANSLATIONREVISION';
	                                    } else if($scope.model.status=='DELIVERED' && !$scope.displayStatus){//CLIENT
	                                    	$scope.message = 'labels.TRANSLATIONDELIVERED';
	                                    	var aId = $scope.model.id;
	                                    	$scope.showBack = true;
											$scope.model.backStatus = $scope.project.dtp ? 'REVISION' : 'IMPORT';
											$scope.dfType = 'translation';
											$scope.dfField = 'revision|delivery';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field=revision|delivery', { cache: false }).then(
	                                                function(response){
	                                                    $scope.downloadFiles = response;
														$scope.filesDownloaded = true
	                                                },
	                                                function(response){

	                                                }).catch(console.error);
										} else if($scope.model.status=='REVIEW'){ //CLIENT
											D.load('account', $scope.model.reviewer).then(function(r){
												$scope.reviewer = r
											})
										}
		

                                    } else if($rootScope.user.groupType=='ADMIN'){

										if($scope.model.status=='TRANSLATION' && !$scope.displayStatus){
											$scope.forceQACheckForm = {
												title: 'labels.FORCEQACHECK',
                                                status: '',
                                                type: 'translation',
                                                model: $scope.model,
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.FORCEQACHECK',
                                                        labelColumn: 0
                                                    }
                                                ],
                                                submit: function(){
													$scope.confirmLabel = 'CONFIRMFORCEQACHECK';
                                                	ngDialog.openConfirm({
                                                        template: '/app/views/entities/confirm-withlabel.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                      }).then(function (value) {
                                                    	  $scope.forceQACheckForm.status = 'submitting';
														  $scope.forceQACheckForm.model.action = 'translate';
    	                                                    D.save('translation', $scope.model).then(
    	                                                        function(){
    	                                                        	$timeout(function(){ $state.go('app.entity', {
    	                					        					 type: 'translation',
    	                					        					 filter: $scope.model.id,
    	                					        					 action: 'view'
    	                					        				 }, { reload: true }); }, CONFIG.stateGoTimeout)
    	                                                        }
    	                                                        
    	                                                    ).catch(function(){
    	                                                        	$scope.forceQACheckForm.status = 'error';
    	                                                        });
                                                      });
                                                }
											}
										}

                                        $scope.forceDeliveryForm = {
                                                title: 'labels.FORCEDELIVERY',
                                                status: '',
                                                type: 'translation',
                                                model: $scope.model,
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.FORCEDELIVERY',
                                                        labelColumn: 0
                                                    }
                                                ],
                                                submit: function(){
                                                	ngDialog.openConfirm({
                                                        template: '/app/views/entities/translation-confirmdeliver.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                      }).then(function (value) {
                                                    	  $scope.forceDeliveryForm.status = 'submitting';
														  $scope.forceDeliveryForm.model.action = 'deliver';
														  $scope.forceDeliveryForm.model.forceDelivery = true
    	                                                    D.save('translation', $scope.model).then(
    	                                                        function(response){
    	                                                        	$timeout(function(){ $state.go('app.entity', {
    	                					        					 type: 'project',
    	                					        					 filter: $scope.model.project,
    	                					        					 action: 'process'
    	                					        				 }, { reload: true }); }, CONFIG.stateGoTimeout)
    	                                                        }
    	                                                        
    	                                                    ).catch(function(err){
    	                                                        	$scope.forceDeliveryForm.status = 'error';
																	if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
																		if(err.data.msg.indexOf('webdavFileExists=')===0){
																			$scope.forceDeliveryForm.errorLabel = $filter('translate')('labels.WEBDAVFILEEXISTS', { file: err.data.msg.substring('webdavFileExists='.length) })
																		}
																	}										
    	                                                        });
                                                      });
                                                }
											}
											
											$scope.forceLayoutForm = {
                                                title: 'labels.SENDLAYOUT',
                                                status: '',
                                                type: 'translation',
                                                model: $scope.model,
                                                fields: [
                                                    {
                                                        available: true,
                                                        type: 'submit',
                                                        name: 'empty',
                                                        label: 'labels.SENDLAYOUT',
                                                        labelColumn: 0
                                                    }
                                                ],
                                                submit: function(){
                                                	ngDialog.openConfirm({
                                                        template: '/app/views/entities/confirm.html',
                                                        className: 'ngdialog-theme-default',
                                                        scope: $scope
                                                      }).then(function (value) {
                                                    	  $scope.forceLayoutForm.status = 'submitting';
                                                    	  $scope.forceLayoutForm.model.action = 'layout';
    	                                                    D.save('translation', $scope.model).then(
    	                                                        function(response){
    	                                                        	$timeout(function(){ $state.go('app.entity', {
    	                					        					 type: 'project',
    	                					        					 filter: $scope.model.project,
    	                					        					 action: 'process'
    	                					        				 }, { reload: true }); }, CONFIG.stateGoTimeout)
    	                                                        }
    	                                                        
    	                                                    ).catch(function(response){
    	                                                        	$scope.forceLayoutForm.status = 'error';
    	                                                        });
                                                      });
                                                }
                                            }

	                                    if($scope.model.status=='TRANSLATION' && !$scope.displayStatus){//ADMIN
											$scope.message = 'labels.TRANSLATIONTRANSLATION';
											if($scope.model.hasZeroWords){
												$scope.message = 'labels.TRANSLATIONSUPPLIERREVISION'
												if($scope.model.opts.linguisticTask){
													$scope.message = 'labels.TRANSLATIONLINGUISTICTASK'
												}
											}
										} else if($scope.model.status=='IMPORT' && !$scope.displayStatus){//ADMIN
											if($scope.model.opts && $scope.model.opts.reviewStatus=='waitReview'){
												$scope.message = 'labels.TRANSLATIONWAITREVIEW'
											}
											if($scope.model.opts && $scope.model.opts.reviewStatus=='underReview'){
												$scope.message = 'labels.TRANSLATIONUNDERREVIEW'
											}
											$scope.forceLayoutForm = null;
											var aId = $scope.model.id;
											$scope.dfType = 'translation';
											$scope.dfField = 'translation';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field=translation', { cache: false }).then(
	                                                function(response){
														$scope.downloadFiles = response;
														$scope.filesDownloaded = true
														$scope.syncField = {
															sync: {
																download: true,
																folder: $scope.model.opts && $scope.model.opts.reviewStatus=='reviewed' ? 'reviewTarget' : 'translationTarget',
																lang: $rootScope.mqLanguageCode($scope.model.destination)
															},
															bucket: $rootScope.bucketName($scope.project.group)
														}
	                                                }).catch(console.error);
	                                    	$scope.showBack = true;
	                                    	$scope.model.backStatus = 'TRANSLATION';
											if($scope.project.opts.separateOffers){
												D.query('project', 'code=' + $scope.project.code.replace('-T', '-I')).then(function(response){
													$scope.dtpProject = response[0]
													D.load('translation', $scope.model.id.replace($scope.project.id, $scope.dtpProject.id)).then(function(response){
														$scope.dtpTranslation = response
														if(!$scope.dtpTranslation.id) {
															$scope.missingDtpTranslation = true
															return
														}
														$scope.uploadForm = {
															title: 'labels.LOADFILESFORDTP',
															titleParams: { lang: $scope.dtpTranslation.destination},
															status: 'notsubmittable',
															type: 'translation',
															model: $scope.dtpTranslation,
															refreshFile: function(data){
																if($rootScope.files['translation'+this.model.id+'layout'] && $rootScope.files['translation'+this.model.id+'layout'].length>0 && this.status!='submitting')
																	this.status = '';
																else
	                                                				this.status = 'notsubmittable';
															},
															fields: [
																{
																	available: true,
																	type: 'file',
																	name: 'layout',
																	canUpload: true,
																	noLabel: true,
																	inputColumn: 12,
																	limit: -1,
																	sync: {
																			folder: 'dtpSource', 
																			upload: true,
																			lang: $rootScope.mqLanguageCode($scope.dtpTranslation.destination),
																			code: $scope.dtpProject.code
																	},
																	bucket: $rootScope.bucketName($scope.project.group),
																	filesSelectable: $rootScope.user.admin,
																	selectionActions: [
																		{ icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
																	] 
																},{
																	available: true,
																	type: 'submit',
																	name: 'empty',
																	label: 'labels.SENDLAYOUT',
																	labelColumn: 0
																}
															],
															submit: function(){
																this.status = 'submitting';
																this.model.action = 'layoutFromT';
																this.model.deliverTranslation = $scope.model.id
																D.save('translation', this.model).then(
																	function(response){ //viene restituita la translation originale
																		$scope.model = response;
																		$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
																		$scope.uploadForm.status = 'notsubmittable';
																		$scope.uploadForm.showSuccess=true;
																		$scope.init()
																	}
																	
																).catch(function(response){
																		$scope.uploadForm.status = 'error';
																	});
	
															}
														}
													})
												})
											} else {
												$scope.uploadForm = {
														title: $scope.project.dtp ? 'labels.LOADFILESFORDTP' : 'labels.LOADFILESNODTP',
														titleParams: { lang: $scope.model.destination},
														status: 'notsubmittable',
														type: 'translation',
														model: $scope.model,
														refreshFile: function(data){
															if($rootScope.files['translation'+this.model.id+($scope.project.dtp ? 'layout' : 'delivery')] && $rootScope.files['translation'+this.model.id+($scope.project.dtp ? 'layout' : 'delivery')].length>0 && this.status!='submitting')
																this.status = '';
															else
	                                                			this.status = 'notsubmittable';
														},
														fields: [
															{
																available: true,
																type: 'file',
																name: $scope.project.dtp ? 'layout' : 'delivery',
																canUpload: true,
																noLabel: true,
																inputColumn: 12,
																limit: -1,
																sync: {
																		folder: ($scope.project.dtp ? 'dtpSource' : 'delivery'), 
																		upload: true,
																		lang: $rootScope.mqLanguageCode($scope.model.destination),
																		code: $scope.project.code
																},
																bucket: $rootScope.bucketName($scope.project.group),
																filesSelectable: $rootScope.user.admin,
																selectionActions: [
																	{ icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
																] 
															},{
																available: true,
																type: 'submit',
																name: 'empty',
																label: $scope.project.dtp ? 'labels.SENDLAYOUT' : 'labels.SENDDELIVERY',
																labelColumn: 0
															}
														],
														submit: function(){
															this.status = 'submitting';
															this.model.action = $scope.project.dtp ? 'layout' : 'deliver';
															D.save('translation', this.model).then(
																function(response){
																	$scope.model = response;
																	$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
																	$scope.uploadForm.status = 'notsubmittable';
																	$scope.uploadForm.showSuccess=true;
																	$scope.init()
																}
																
															).catch(function(err){
																	$scope.uploadForm.status = 'error';
																	if(err.data && err.data.exc && err.data.exc=='InvalidValueException'){
																		if(err.data.msg.indexOf('webdavFileExists=')===0){
																			$scope.uploadForm.errorLabel = $filter('translate')('labels.WEBDAVFILEEXISTS', { file: err.data.msg.substring('webdavFileExists='.length) })
																		}
																	}	
																});

														}
													}
												};

												if($scope.project.withQAi){
													D.query('qaiprocess', 'projectid=' + $scope.project.id + '&targetlang=' + $scope.model.destination).then(function(response){
														let qaiExists = !!(response[0] && response[0].id)
														if(qaiExists){
															response[0].url = { action:'process', type: 'qai', filter: response[0].id }
														}
														$scope.qaiForm = {
															title: qaiExists ? 'labels.OPENQAIFROMTRANSLATION' : 'labels.CREATEQAIFROMTRANSLATION',
															status: '',
															model: { qai: response[0], status: response[0] && $filter('translate')('enums.qaiProcessStatus.' + response[0].status) },
															fields: [
																{
																	available: qaiExists,
																	type: 'link',
																	name: 'qai'
																},{
																	available: qaiExists,
																	type: 'static',
																	name: 'status'
																},
																{
																	available: !qaiExists,
																	type: 'submit',
																	label: 'sidebar.nav.NEWQAIPROCESS'
																}
															],
															submit: function(){
																$scope.qaiFromTranslationForm = {
																	title: 'labels.CREATEQAIFROMTRANSLATION',
																	status: '',
																	type: 'qaiprocess',
																	model: {
																		tempId: $scope.project.id.replace(/-/g, '') + $scope.model.destination.replace(/_/g, '').toLowerCase(),
																		filesFromTranslation: $scope.downloadFiles.slice(),
																		fromTranslation: $scope.model.id
																	},
																	fields: [
																		{
																			available: true,
																			name: 'filesFromTranslation',
																			type: 'selectablefiles',
																			files: $scope.downloadFiles.slice().filter(f => { return f.extension=='mqxliff' || f.extension=='mqxlz' }),
																			selectorOptions: {
																				extensions: 'mqxlz,mqxliff'
																			}
																		},{
																			available: true,
																			name: 'file',
																			label: 'fields.ADDITIONALFILES',
																			type: 'file',
																			canUpload: true,
																			limit: -1,
																			allow: 'mqxlz|mqxliff',
																			bucket: $rootScope.bucketName($scope.project.group),
																			filesSelectable: $rootScope.user.admin,
																			selectionActions: [
																				{ icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
																			] 
																		},{
																			available: true,
																			type: 'submit',
																			label: 'labels.ADDNEWPROCESS'
																		}
																	],
																	submit: function(){
																		$scope.qaiFromTranslationForm.status = 'submitting'
																		D.save('qaiprocess', $scope.qaiFromTranslationForm.model).then(function(response){
																			ngDialog.close();
																			$state.go('app.entity', { action: 'process', type: 'qai', filter: response.id })
																		}).catch(function(err){
																			$scope.qaiFromTranslationForm.status = 'error'
																		})
																	}
																}
			
																ngDialog.open({
																	template: '/app/views/entities/translation-createqai.html',
																	className: 'ngdialog-theme-default ngdialog-theme-large',
																	scope: $scope
																});
															}
														}
													})
													
														
												}
												

	                                    } else if($scope.model.status=='LAYOUT' && !$scope.displayStatus){//ADMIN
											$scope.message = 'labels.TRANSLATIONLAYOUT';
											$scope.forceLayoutForm = null;
											$scope.uploadForm = {
												title: $scope.project.dtp ? 'labels.LOADFILESFORDTP' : 'labels.LOADFILESNODTP',
												titleParams: { lang: $scope.model.destination},
												status: 'notsubmittable',
												type: 'translation',
												model: $scope.model,
												fields: [
													{
														available: true,
														type: 'file',
														name: $scope.project.dtp ? 'layout' : 'delivery',
														canUpload: false,
														noLabel: true,
														inputColumn: 12,
														limit: -1,
														cantDelete: true,
														bucket: $rootScope.bucketName($scope.project.group)
													}
												],
											}
										} else if($scope.model.status=='REVISION' && !$scope.displayStatus){//ADMIN
											$scope.forceLayoutForm = null;
											var aId = $scope.model.id;
											$scope.dfType = 'translation';
											$scope.dfField = 'revision';
											$scope.dfId = aId;
											$scope.dfExt = ''
											$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
											$scope.filesDownloaded = false
	                                    	D.query('file', 'type=translation&entityId='+aId+'&field=revision', { cache: false }).then(
	                                                function(response){
														$scope.downloadFiles = response;
														$scope.filesDownloaded = true
														$scope.syncField = {
															sync: {
																download: true,
																folder: 'delivery',
																copyTo: $scope.project.dtp ? ['dtpTarget'] : [],
																lang: $rootScope.mqLanguageCode($scope.model.destination)
															},
															bucket: $rootScope.bucketName($scope.project.group) 
														}
	                                                }).catch(console.error);
											
											//copia dei file xliff tradotti
											if($scope.project.dtp && $scope.model.review && !$scope.model.anticipateReview){
												$scope.filesDownloaded = false
												D.query('file', 'type=translation&entityId='+aId+'&field=translation', { cache: false }).then(
													function(response){
														$scope.downloadFiles2 = response;
														$scope.filesDownloaded = true
														$scope.syncField2 = {
															sync: {
																download: true,
																folder: 'reviewTarget',
																lang: $rootScope.mqLanguageCode($scope.model.destination)
															},
															bucket: $rootScope.bucketName($scope.project.group)
														}
													}).catch(console.error);	
											}

	                                    	$scope.showBack = true;
	                                    	$scope.model.backStatus = 'LAYOUT';
	                                    	$scope.uploadForm = {
	                                                title: 'labels.DELIVERFILES',
	                                                titleParams: { lang: $scope.model.destination},
	                                                status: '',
	                                                type: 'translation',
	                                                model: $scope.model,
	                                                fields: [
	                                                    {
	                                                        available: true,
	                                                        type: 'submit',
	                                                        name: 'empty',
	                                                        label: 'labels.SENDDELIVERY',
	                                                        labelColumn: 0
	                                                    }
	                                                ],
	                                                submit: function(){
	                                                	ngDialog.openConfirm({
	                                                        template: '/app/views/entities/translation-confirmdeliver.html',
	                                                        className: 'ngdialog-theme-default',
	                                                        scope: $scope
	                                                      }).then(function (value) {
	                                                    	  $scope.uploadForm.status = 'submitting';
	                                                    	  $scope.uploadForm.model.action = 'deliver';
			                                                    D.save('translation', $scope.uploadForm.model).then(
			                                                        function(response){
																		$scope.model = response;
																		$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
			                                                        	$scope.uploadForm.status = 'notsubmittable';
			                                                        	$scope.uploadForm.showSuccess=true;
																		$scope.init()
			                                                        }
			                                                        
			                                                    ).catch(function(response){
			                                                        	$scope.uploadForm.status = 'error';
			                                                        });
	                                                      });
	                                                }
	                                            };
	                                    } else if($scope.model.status=='DELIVERED' && !$scope.displayStatus){//ADMIN
	                                    	$scope.message = 'labels.TRANSLATIONDELIVERED';
											$scope.forceDeliveryForm = null;
											$scope.forceLayoutForm = null;
											var aId = $scope.model.id;
											$scope.filesDownloaded = false
											D.query('file', 'type=translation&entityId='+aId+'&field=revision|delivery', { cache: false }).then(
												function(response){
													$scope.downloadFiles = response;
													$scope.filesDownloaded = true
													$scope.webdavFiles = $scope.project.group=='aag' && $rootScope.user.admin
													$scope.syncField = {
														sync: {
															download: true,
															folder: 'delivery',
															//copyTo: $scope.project.dtp ? ['dtpTarget'] : [],
															lang: $rootScope.mqLanguageCode($scope.model.destination),
															noUnzip: true
														},
														bucket: $rootScope.bucketName($scope.project.group) 
													}
												}).catch(console.error);

												//copia dei file xliff tradotti
												if($scope.project.dtp && $scope.model.review && !$scope.model.anticipateReview){
													$scope.filesDownloaded = false
													D.query('file', 'type=translation&entityId='+aId+'&field=translation', { cache: false }).then(
														function(response){
															$scope.downloadFiles2 = response;
															$scope.filesDownloaded = true
															$scope.syncField2 = {
																sync: {
																	download: true,
																	folder: 'reviewTarget',
																	lang: $rootScope.mqLanguageCode($scope.model.destination)
																},
																bucket: $rootScope.bucketName($scope.project.group)
															}
														}).catch(console.error);	
												}
											} else if(($scope.model.status=='REVIEW' || $scope.displayStatus=='REVIEW') && $scope.model.opts.reviewMode=='memoQ'){//ADMIN
											
												D.load('account', $scope.model.reviewer).then(function(r){
													$scope.reviewer = r
												})

												var aId = $scope.model.id;
												$scope.dfType = 'translation';
												$scope.dfField = 'translation';
												$scope.dfId = aId;
												$scope.dfExt = ''
												$scope.dfName = $scope.project.code + '_' + $scope.model.destination + '_' + $filter('translate')('enums.translationStatus.'+$scope.model.status).replace(/\s/g,'_')
												$scope.filesDownloaded = false
												D.query('file', 'type=translation&entityId='+aId+'&field=translation', { cache: false }).then(
														function(response){
															$scope.downloadFiles = response;
															$scope.filesDownloaded = true
															$scope.syncField = {
																sync: {
																	download: true,
																	folder: $scope.model.opts && $scope.model.opts.reviewStatus=='reviewed' ? 'reviewTarget' : 'translationTarget',
																	lang: $rootScope.mqLanguageCode($scope.model.destination)
																},
																bucket: $rootScope.bucketName($scope.project.group)
															}
														}).catch(console.error);
	
												$scope.disabledUploadForm = false
												$scope.uploadForm = {
														title: '',
														titleParams: { lang: $scope.model.destination},
														status: '',
														type: 'translation',
														model: $scope.model,
														fields: [
															{
																available: true,
																type: 'submit',
																name: 'empty',
																label: 'labels.SENDREVIEWCOMPLETED',
																labelColumn: 0,
																cls: 'btn-lg'
															}
														],
														submit: function(){
															this.status = 'submitting';
															this.model.action = $scope.project.dtp ? 'revision' : 'translate';
															D.save('translation', this.model).then(
																function(response){
																	$scope.model = response;
																	$scope.currentStatusIndex = $scope.statuses.indexOf($scope.model.status);
																	$scope.uploadForm.status = 'notsubmittable';
																	$scope.uploadForm.showSuccess=true;
																	$scope.uploadForm.fields.forEach(function(f){
																		if(f.type=='file') f.cantDelete = true;
																	})
																	$scope.init()
																}
																
															).catch(function(response){
																	$scope.uploadForm.status = 'error';
																});
	
														}
													};
	
	                                    }
                                    }

                                }
                                
                            ).catch(function(error){
                                    $scope.error = error;
                                });


                    }
                    
                ).catch(function(error){
                        $scope.error = error;
                    });

            $scope.form = {
                title: 'labels.EDITTEMPLATE',
                status: '',
                type: 'template',
                fields: [
                    {
                        available: true,
                        type: 'static',
                        name: 'template'
                    },{
                        available: true,
                        type: 'static',
                        name: 'language'
                    },{
                        available: true,
                        type: 'textarea',
                        name: 'text'
                    },{
                        available: true,
                        type: 'editor',
                        name: 'html'
                    },{
                        available: true,
                        type: 'separator'
                    },{
                        available: true,
                        type: 'submit',
                        name: 'empty',
                        value: 'fields.SUBMIT'
                    }
                ],
                submit: function(){
                    $scope.form.status = 'submitting';
                    D.save($scope.type, $scope.form.model).then(
                        function(response){
                            $scope.form.status = 'notsubmittable';
                            $scope.uploadForm.showSuccess=true;
                        }
                        
                    ).catch(function(response){
                            $scope.form.status = 'error';
                        });
                }
            };




        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

	$scope.init();
	
	$scope.addQAError = function(){
		/*$scope.confirmLabel = 'QAERRORSCONFIRMADD';
		ngDialog.openConfirm({
			template: '/app/views/entities/confirm-withlabel.html',
			className: 'ngdialog-theme-default',
			scope: $scope
		}).then(function (value) {*/
			$scope.model.action = 'addQAError';
			$scope.model.QAErrors = '…'
			D.save('translation', $scope.model).then(function(response){
				$scope.model = response;
			}).catch(console.error);
		//});
	}

	$scope.undoQAError = function(){
		$scope.confirmLabel = 'QAERRORSCONFIRMUNDO';
		ngDialog.openConfirm({
			template: '/app/views/entities/confirm-withlabel.html',
			className: 'ngdialog-theme-default',
			scope: $scope
		}).then(function (value) {
			$scope.model.action = 'undoQAError';
			D.save('translation', $scope.model).then(function(response){
				$scope.model = response;
			}).catch(console.error);
		});
	}

	$scope.viewGlossary = function(){

        ngDialog.open({
            template: '/app/views/entities/popup-glossary.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
    }

	$scope.changeStatusPopup = function(){

		$scope.changeTranslationStatusForm = {
			title: 'labels.CHANGETRANSLATIONSTATUS',
			status: '',
			legend: 'labels.CHANGETRANSLATIONSTATUSFORM',
			model: $scope.model,
			fields: [
				{
					available: true,
					name: 'newStatus',
					type: 'select',
					data: $scope.statuses.filter(s => s!=$scope.model.status).map(s => { return { value: s, label: $filter('translate')('enums.translationStatus.' + s) }}),
					valueField: 'value',
					labelField: 'label'
				},
				{
					available: true,
					type: 'submit'
				}
			],
			submit: function(){
				ngDialog.openConfirm({
					template: '/app/views/entities/confirm.html',
					className: 'ngdialog-theme-default',
					scope: $scope
				}).then(function (value) {
					$scope.changeTranslationStatusForm.status = 'submitting'
					$scope.model.action = 'changeTranslationStatus';
					D.save('translation', $scope.model).then(function(response){
						$scope.model = response;
						$scope.changeTranslationStatusForm.status = ''
						ngDialog.close();
					}).catch(function(err){
						$scope.changeTranslationStatusForm.status = 'error'
					});
				});
			}
		}

		ngDialog.open({
            template: '/app/views/entities/translation-changestatus.html',
            className: 'ngdialog-theme-default ngdialog-theme-large',
            scope: $scope
        })
	}


	$scope.$on('$destroy', function iVeBeenDismissed() {
		
	})

}]);
